import type { ReactElement, ReactNode } from 'react';

/**
 * Abgesetzte Fläche für zusammengehörige Angaben (§40.4).
 *
 * Wie {@link Knopf} eine Zusammenfassung der bis S2 wiederholten Klassenkette. Die Farben kommen
 * ausschließlich aus den Designtokens in `index.css`; hier steht kein Einzelwert.
 */
export function Karte({
  children,
  className,
  betont = false,
}: {
  children: ReactNode;
  className?: string;
  /** Hebt die Karte hervor — etwa die aktive Abstimmung im Teilnehmerbereich. */
  betont?: boolean;
}): ReactElement {
  const klassen = [
    'bg-flaeche rounded-xl border p-4 shadow-sm',
    betont ? 'border-akzent/40' : 'border-rand',
    className ?? '',
  ]
    .filter((teil) => teil !== '')
    .join(' ');

  return <section className={klassen}>{children}</section>;
}
